import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=2b7f4f68&scoped=true&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=2b7f4f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f4f68",
  null
  
)

export default component.exports